import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import VehicleCard from './VehicleCard';
import { VehicleAPI } from '../mock';

export default function RecentVehicles() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    VehicleAPI.list({ sort: 'newest', limit: 6 })
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (!loading && items.length === 0) return null;

  return (
    <section className="py-20 lg:py-28 bg-[#fafafa] border-y border-black/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-white border border-black/10 px-3.5 py-1.5 rounded-full text-[11px] tracking-[0.18em] uppercase font-semibold">
              <Clock size={12} className="text-[#e11d2c]" /> Recently Added
            </div>
            <h2 className="font-display mt-5 text-[36px] sm:text-[48px] lg:text-[56px] font-black leading-[1.02] tracking-tight text-black">
              Fresh off the boat.
            </h2>
            <p className="mt-4 text-black/60 text-[15px] max-w-lg">The latest imports cleared, certified, and now on the showroom floor.</p>
          </div>
          <Link to="/inventory" className="hidden lg:inline-flex items-center gap-2 text-black font-semibold hover:text-[#e11d2c] transition-colors">
            View all <ArrowRight size={16} />
          </Link>
        </div>

        {loading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 3 }).map((_, i) => <div key={i} className="aspect-[4/3] bg-black/5 rounded-2xl animate-pulse" />)}
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map(v => <VehicleCard key={v.id} v={v} />)}
          </div>
        )}
      </div>
    </section>
  );
}
